import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import {store, persistor}  from './redux/app/store';
import './assets/styles/_global.scss';
import { ApolloClient, ApolloProvider, HttpLink, InMemoryCache, from } from '@apollo/client'
import {setContext} from '@apollo/client/link/context'
import { onError } from "@apollo/client/link/error";
import {config} from './config/config'
import {Amplify} from 'aws-amplify'
import {fetchAuthSession, getCurrentUser} from 'aws-amplify/auth'
import { GlobalProvider } from './MeetContext/MeetContext';
import { MeetingProvider } from 'amazon-chime-sdk-component-library-react';
import { ChimeMeetingProvider } from './Chime/ChimeMeetingContext';
import { logout as authLogout } from './redux/slices/authSlice';
import { PersistGate } from 'redux-persist/integration/react';
import ToasterWithMessage from './components/toaster';
import { validateJwtToken } from './utils/helper';
const { error: errorToast } = ToasterWithMessage();

Amplify.configure(config.amplifyConfig);

//get new accessToken
const getNewAccessToken = async () => {
  try {
    const session = await fetchAuthSession({ forceRefresh: true });
    if (!session?.tokens?.accessToken) {
      throw new Error("Refresh token expired or invalid session");
    }
    return session;
  } catch (error: any) {
    console.error("[Log] Token refresh failed:", error);
    throw error; 
  }
};

//checking that the accessToken is Expired or not`
const setAuthorizationLink = setContext(
  async (data : any) => {
    let accessToken: any = localStorage.getItem(Object.keys(localStorage).find((key) => key.includes('accessToken')) as string) || '';
    let saId:any = localStorage.getItem('saId')
    let virutalProgramId:string | null = localStorage.getItem('virtualProgramId')
    const validation =  await validateJwtToken(accessToken);
        console.log(data.operationName, "data")
    if (!validation?.isValid && accessToken) {
    try {
      const session : any = await getNewAccessToken();
      const refreshedToken = session?.tokens?.accessToken?.toString();
      accessToken = refreshedToken || "";
    } catch (err) {
      console.log("Token refresh failed, skipping request");
      errorToast("Session Expired..")
      store.dispatch(authLogout()); 
      throw new Error("Session Expired..");
    }
  }
    return _buildAuthHeader(accessToken,saId, virutalProgramId);
  }
);


const _buildAuthHeader = (token: string,saId:string, virutalProgramId: string |null ) => {
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      saId:saId?saId:'',
      vprogramid : virutalProgramId ? virutalProgramId : '',
      schooltype : "virtual"
    },
  };
};

const getCurrentUserDetail = async () => {
  return await getCurrentUser();
}

const logout = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      console.error("[GraphQL Error]:", err);
      const isAuthError = err?.message?.toLowerCase()?.includes("unauthorized") ||
                          err?.message?.toLowerCase()?.includes("user needs to be authenticated") ||
                          err?.message?.toLowerCase()?.includes("token expired");

      if (isAuthError) {
        errorToast(err?.message)
        store.dispatch(authLogout()); 
      }
    }
  }

  if (networkError) {
    console.error("[Network Error]:", networkError);
  }
});

const httpLink = new HttpLink({ uri: config.backend_url });
const client = new ApolloClient({
  link: from([logout, setAuthorizationLink, httpLink]),
  cache: new InMemoryCache({
    addTypename: false
  }),
  defaultOptions: {
    query: {
      fetchPolicy: "network-only",
      errorPolicy: "all",
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ApolloProvider client={client}>
    <GlobalProvider>
      <MeetingProvider>
        <ChimeMeetingProvider>
          <BrowserRouter>
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <App />
              </PersistGate>
            </Provider>
          </BrowserRouter>
        </ChimeMeetingProvider>
      </MeetingProvider>
    </GlobalProvider>
  </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
